module.exports = __webpack_public_path__ + "img/01-2.51dba8f0.png";